
export const SET_CLIENTES_USUARIO = 'usuariocliente/SET_CLIENTES_USUARIO';

export const setClientesUsuario = (clientesUsuario) => {
  return {
    type: SET_CLIENTES_USUARIO,
    payload: clientesUsuario
  }
}